var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c('div',{staticClass:"d-flex flex-column h-100"},[_c('div',{staticClass:"flex-grow-1"},[_c('NavBar'),_c('router-view')],1),_c('footer',{attrs:{"id":"page-footer"}},[_c('Footer')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }